(function () {
  const grid = document.getElementById('wishlist-grid');
  const emptyState = document.getElementById('wishlist-empty');
  if (!grid) return;

  // Toggling (click handling) is owned by wishlist.js, loaded site-wide via
  // the bottom nav — it dispatches 'wishlist:change' on every toggle, which
  // is this page's only cue to re-render.
  async function render() {
    const handles = (window.CrockeraWishlist && window.CrockeraWishlist.getHandles()) || [];
    grid.innerHTML = '';

    if (handles.length === 0) {
      emptyState.hidden = false;
      return;
    }
    emptyState.hidden = true;

    const products = await Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    );

    products.filter(Boolean).forEach((product) => {
      const price = (product.price / 100).toLocaleString(undefined, { minimumFractionDigits: 2 });
      const card = document.createElement('div');
      card.className = 'grid__item';
      card.innerHTML = `
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media">
            <div class="card__inner ratio color-${window.wishlistCardColorScheme || 'scheme-2'} gradient" style="--ratio-percent: 100%;">
              <div class="card__media">
                <button type="button" class="wishlist-button wishlist-button--active" data-wishlist-handle="${product.handle}" aria-pressed="true" aria-label="Remove from wishlist">
                  ${window.wishlistHeartSvg || '♥'}
                </button>
                <a href="${product.url}">
                  <img src="${product.featured_image}" alt="${product.title}" loading="lazy" style="width:100%;height:100%;object-fit:cover;">
                </a>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading"><a href="${product.url}" class="full-unstyled-link">${product.title}</a></h3>
                <span class="price">${price}</span>
              </div>
            </div>
          </div>
        </div>`;
      grid.appendChild(card);
    });
  }

  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('wishlist:change', render);
})();
